export const prodHosts = [
  'www.smartbox.com',
  'www.dakotabox.es',
  'www.dakotabox.fr',
  'www.emozione3.it',
  'www.lavidaesbella.es',
  'www.bongo.nl',
  'www.bongo.be',
  'www.cadeaubox.be',
];

export const preProdHosts = [
  'front-pp-u3.smartbox.com',
  'front-royal-pp-u3.smartbox.com',
  'preprod.dakotabox.es',
  'preprod.dakotabox.fr',
  'preprod.emozione3.it',
  'preprod.lavidaesbella.es',
  'preprod.bongo.nl',
  'preprod.bongo.be',
  'preprod.cadeaubox.be',
];

export const localHostPatterns = [/localhost:[0-9]{4}/, /local\.search-components\.smartbox\.com/];

export const additionDomainsToLangMap = {
  'com/fr/': 'fr',
  'com/es/': 'es',
  'com/it/': 'it',
  'com/de/': 'de',
  'com/dk/': 'da',
  'com/se/': 'sv',
  'com/ch/': 'de',
  'com/ch/fr/': 'fr',
  'com/ch/it/': 'it',
  'com/ch/de/': 'de',
  'es/': 'es',
  'fr/': 'fr',
  'it/': 'it',
  'be/': 'nl',
  'nl/': 'nl',
  'net/de/': 'de',
  'be/fr/': 'fr',
  'be/nl/': 'nl',
};

export const languageList = ['en', 'fr', 'es', 'it', 'de', 'nl', 'sv', 'da'];

const urlPatterns = [
  /https?:\/\/[^/]+\/(ch\/it|ch\/fr|ch\/de)$/i,
  /https?:\/\/[^/]+\/(ch\/it|ch\/fr|ch\/de)\//i,
  /https?:\/\/[^/]+\/(ch\/it|ch\/fr|ch\/de)\?/i,
  /https?:\/\/[^/]+\/(cb\/fr|cb\/nl)$/i,
  /https?:\/\/[^/]+\/(cb\/fr|cb\/nl)\//i,
  /https?:\/\/[^/]+\/(cb\/fr|cb\/nl)\?/i,
  /https?:\/\/[^/]+\/(bb\/fr|bb\/nl)$/i,
  /https?:\/\/[^/]+\/(bb\/fr|bb\/nl)\//i,
  /https?:\/\/[^/]+\/(bb\/fr|bb\/nl)\?/i,
  /https?:\/\/[^/]+\/[a-z]{2}$/i,
  /https?:\/\/[^/]+\/[a-z]{2}\//i,
  /https?:\/\/[^/]+\/[a-z]{2}\?/i,
  /https?:\/\/[^/]+/i,
];

const validSearchParams = ['sblFilterValue', 'brand', 'country', 'language', 'debug', 'feature-flags', 'page.number', 'page.size', 'page.scroll', 'text', 'sort', 'context.sort.position.enable_smart_sort', 'context.sort.distance.current_position', 'context.filter.coordinates.place'];

export function baseUrl() {
  const url =
    process.env.NODE_ENV === 'development' && sessionStorage.getItem('baseUrlOverride') !== null
      ? sessionStorage.getItem('baseUrlOverride')
      : window.location.href;

  return getBaseUrl(url);
}

export function getBaseUrl(url) {
  for (let i = 0; i < urlPatterns.length; i++) {
    const match = url.match(urlPatterns[i]);
    if (match) return match[0].replace(/(\?|\/)$/, '') + '/';
  }
  return '/'; // fallback to relative path
}

function getParamsAndFragment(urlString) {

  const checkedUrl = checkUrlString(urlString);
  const url = new URL(checkedUrl);
  const params = new URLSearchParams(url.search);
  const paramsArray = Array.from(params, ([key, value]) => ({ key, value }));

  // check if url.hash exists
  let fragmentArray = [];
  if (url.hash) {
    const fragment = new URLSearchParams('?' + url.hash.substring(1)); // remove the '#' at the start
    fragmentArray = Array.from(fragment, ([key, value]) => ({ key, value }));
  }
  return { '?': paramsArray, '#': fragmentArray };
}

function checkUrlString(inputString) {
  if (!inputString.includes('#')) {
    return inputString;
  }

  const hashIndex = inputString.indexOf('#');
  const questionMarkIndex = inputString.indexOf('?');

  if (questionMarkIndex === -1 || (hashIndex !== -1 && hashIndex < questionMarkIndex)) {
    const beforeHash = inputString.substring(0, hashIndex);
    const hashPart = inputString.substring(hashIndex, questionMarkIndex !== -1 ? questionMarkIndex : undefined);
    const afterHash = inputString.substring(questionMarkIndex !== -1 ? questionMarkIndex : inputString.length);

    return beforeHash + afterHash + hashPart;
  } else {
    return inputString;
  }
}

export const getSearchParams = () => {
  const allParams = getParamsAndFragment(window.location.href);
  let searchParams = allParams['#'];
  const otherParams = allParams['?'];
  searchParams = [...searchParams, ...otherParams];
  searchParams = searchParams.length ? Object.values(searchParams).map(param => {
    return `${ param.key }=${ param.value }`;
  }).join('&') : '';
  return new URLSearchParams('?' + searchParams);
};

export function addQueryParam(paramName, paramValue) {
  const urlSearchParams = getSearchParams();
  urlSearchParams.append(paramName, paramValue);
  setSearchToURL(urlSearchParams);
}

export function deleteQueryParam(...paramNames) {
  const urlSearchParams = getSearchParams();

  for (const param of paramNames) {
    if (!urlSearchParams.has(param)) continue;
    urlSearchParams.delete(param);
  }
  setSearchToURL(urlSearchParams);
}

export function deleteQueryParamByValue(name, value) {
  const urlSearchParams = getSearchParams();

  const entries = urlSearchParams.entries();

  const allEntries = [];
  for (const entry of entries) {
    if (entry[0] === name && entry[1] === value) {
      continue;
    }

    allEntries.push([...entry]);
  }

  setSearchToURL(new URLSearchParams(allEntries));
}

export function getQueryParam(paramName) {
  const urlSearchParams = getSearchParams();

  return urlSearchParams.get(paramName);
}

function getAllQueryParamValues(paramName) {
  const urlSearchParams = getSearchParams();

  return urlSearchParams.getAll(paramName);
}

export function hasQueryParamWithValue(paramName, paramValue) {
  return getAllQueryParamValues(paramName).includes(paramValue);
}

export function getSearchParamsText(allParams) {
  const allEntries = allParams.entries();
  let searchParams = [];
  let nonSearchParams = [];
  for (const entry of allEntries) {
    if (validSearchParams.includes(entry[0]) || entry[0].match(/filter.*/)) {
      searchParams.push({ key: entry[0], value: entry[1] });
    } else {
      nonSearchParams.push({ key: entry[0], value: entry[1] });
    }
  }
  nonSearchParams = nonSearchParams.length ? '?' + Object.values(nonSearchParams).map(param => {
    return `${ param.key }=${ param.value }`;
  }).join('&') : '';
  searchParams = searchParams.length ? '#' + Object.values(searchParams).map(param => {
    return `${ param.key }=${ param.value }`;
  }).join('&') : '';

  return nonSearchParams + searchParams;
}

function setSearchToURL(allParams) {
  const searchText = getSearchParamsText(allParams);

  // Set new url path
  const newRelativePathQuery = window.location.pathname + searchText;
  history.replaceState(null, '', newRelativePathQuery);
}
